export const DEFAULT_PAGE_SIZE =
  Number(process.env.REACT_APP_DEFAULT_PAGE_SIZE) || 100;
export const DEFAULT_PAGE_NUMBER =
  Number(process.env.REACT_APP_DEFAULT_PAGE_SIZE) || 1;
